const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const PHONE_REGEX = /^\+?421\d{9}$/

export function isValidEmail(value: string): boolean {
  const trimmed = value?.trim() ?? ''
  if (!trimmed) return false
  return EMAIL_REGEX.test(trimmed)
}

export function isValidPhone(value: string): boolean {
  const trimmed = value?.trim().replace(/\s/g, '') ?? ''
  if (!trimmed) return false
  return PHONE_REGEX.test(trimmed)
}

export type ValidationErrorKey = 'plugin.customerStep.emailError' | 'plugin.customerStep.phoneError' | null

export function getEmailError(value: string): ValidationErrorKey {
  const trimmed = value?.trim() ?? ''
  if (!trimmed) return 'plugin.customerStep.emailError'
  return EMAIL_REGEX.test(trimmed) ? null : 'plugin.customerStep.emailError'
}

export function getPhoneError(value: string): ValidationErrorKey {
  const trimmed = value?.trim().replace(/\s/g, '') ?? ''
  if (!trimmed) return 'plugin.customerStep.phoneError'
  return PHONE_REGEX.test(trimmed) ? null : 'plugin.customerStep.phoneError'
}
